import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Industries from './pages/Industries';
import TradeHistory from './pages/TradeHistory';
import Contact from './pages/Contact';
import Pricing from './pages/Pricing';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Products />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/trade-history" element={<TradeHistory />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/quote" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Chatbot />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
